import React, { useEffect, Children } from 'react';
import { Phone, ClipboardList, HardHat, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function Process() {
  const {
    t
  } = useLanguage();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const icons = [Phone, ClipboardList, HardHat, CheckCircle2];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="process" className="py-24 bg-gray-50 border-y border-gray-100" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center mb-20" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-black mb-4" data-id="element-149">
            {t.process.title}
          </h2>
          <div className="w-24 h-1.5 bg-brand-blue mx-auto rounded-full" data-id="element-150"></div>
        </div>

        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={controls} className="relative" data-id="element-151">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-gray-200 -z-0" data-id="element-152"></div>
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-brand-red origin-left scale-x-0 -z-0" style={{
          animation: inView ? 'growLine 1.5s ease-out forwards 0.5s' : 'none'
        }} data-id="element-153"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10" data-id="element-154">
            {t.process.steps.map((step, index) => {
            const Icon = icons[index];
            return <motion.div key={index} variants={itemVariants} className="flex flex-col items-center text-center group" data-id="element-155">
                  <div className="w-24 h-24 bg-white rounded-full border-4 border-gray-100 shadow-xl flex items-center justify-center mb-6 group-hover:border-brand-red transition-colors duration-300 relative" data-id="element-156">
                    <div className="absolute -top-3 -right-3 w-8 h-8 bg-brand-blue text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md" data-id="element-157">
                      {index + 1}
                    </div>
                    <Icon className="w-10 h-10 text-brand-blue group-hover:text-brand-red transition-colors duration-300" data-id="element-158" />
                  </div>
                  <h3 className="text-xl font-heading font-bold text-brand-black mb-3" data-id="element-159">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-160">{step.desc}</p>
                </motion.div>;
          })}
          </div>
        </motion.div>

        <style data-id="element-161">{`
          @keyframes growLine {
            from { transform: scaleX(0); }
            to { transform: scaleX(1); }
          }
        `}</style>
      </div>
    </section>;
}